exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#intercom-container{display:none}.tickBackground--2z_N6jl3{width:6rem;height:6rem;border-radius:50%;background:#99c63b;box-shadow:0 10pt 28pt -5pt rgba(27,125,177,.7);display:-webkit-box;display:-moz-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center}@media only screen and (min-width:600px) and (max-width:1023px){.tickBackground--2z_N6jl3{height:8rem;width:8rem}}.tick--3kmuKo9b{height:2.5rem;width:2.5rem}@media only screen and (min-width:600px) and (max-width:1023px){.tick--3kmuKo9b{height:3.5rem;width:3.5rem}}", ""]);

// exports
exports.locals = {
	"tickBackground": "tickBackground--2z_N6jl3",
	"tick": "tick--3kmuKo9b"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[local]--[hash:base64:8]!./~/sass-loader!./src/components/sign_up/shared/animatedTick/styles.scss
// module id = 1038
// module chunks = 0